import { useTranslation } from 'react-i18next';
import { AxiosResponse } from 'axios';
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { IMPORT_EXPORT_PROCESS_TYPE } from 'Common/enums';
import { cancelImportExportStatus } from 'Services';
import { RQ_GET_LIST_IMPORT_EXPORT_STATUS, callAll } from 'Utils';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';

type HookArgs = {
    mutationOptions?: UseMutationOptions<AxiosResponse, unknown, unknown, unknown>;
};

const useCancelImportExportList = ({ mutationOptions }: HookArgs) => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    const { addAlert } = useAlertBanner();
    const { clearAll } = useReduxModal();

    const defaultSuccessHandler = () => {
        clearAll();
        queryClient.invalidateQueries([RQ_GET_LIST_IMPORT_EXPORT_STATUS]);
    };

    const handleOnError = (variables: CancelImportExportVariables) => {
        const isImport = variables.type === IMPORT_EXPORT_PROCESS_TYPE.IMPORT;
        clearAll();
        addAlert({
            id: 'cancel-import-export-error',
            status: 'danger',
            content: isImport ? t('Cancel Import List Failure') : t('Cancel Export List Failure')
        });
    };

    return useMutation(cancelImportExportStatus, {
        onSuccess: callAll(defaultSuccessHandler, mutationOptions?.onSuccess),
        onError: handleOnError
    });
};

export default useCancelImportExportList;
